import { Component, HostBinding, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faMicrosoft } from '@fortawesome/free-brands-svg-icons';
import { ThrottledClickDirective } from 'emg-fe-lib';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { PmValues } from './entities/login.entities';

@Component({
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: true,
	selector: 'login',
	imports: [FaIconComponent, MatButtonModule, ThrottledClickDirective],
	templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit, OnDestroy {
	@HostBinding('class') classes = 'w-screen h-screen bg-login-screen bg-emagine-grey-100 bg-no-repeat bg-contain flex';
	isIframe = false;
	loginDisplay = false;
	pmValues = PmValues;
	icons = { faMicrosoft };

	private readonly _destroying$ = new Subject();
	constructor(
		@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
		private _msalService: MsalService,
		private _authService: AuthService,
		private msalBroadcastService: MsalBroadcastService,
	) { }

	ngOnInit(): void {
		this.setLoginDisplay();

		this.msalBroadcastService.inProgress$
			.pipe(
				filter((status: InteractionStatus) => status === InteractionStatus.None),
				takeUntil(this._destroying$),
			)
			.subscribe(() => {
				this.setLoginDisplay();
				this.checkAndSetActiveAccount();
			});
	}

	setLoginDisplay() {
		const loader = document.getElementById('appLoader') as HTMLElement;
		loader.classList.add('invisible');
		this.loginDisplay = this._msalService.instance.getAllAccounts().length > 0;
	}

	checkAndSetActiveAccount() {
		/**
		 * If no active account set but there are accounts signed in, sets first account to active account
		 * To use active account set here, subscribe to inProgress$ first in your component
		 * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
		 */
		this._authService.checkAndSetActiveAccount();
	}

	loginRedirect() {
		if (this.msalGuardConfig.authRequest) {
			this._msalService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
		} else {
			this._msalService.loginRedirect();
		}
	}

	login() {
		this._authService.loginWithMicrosoft();
	}

	logout() {
		this._msalService.logoutRedirect({ postLogoutRedirectUri: '/login' });
	}

	ngOnDestroy(): void {
		this._destroying$.next(undefined);
		this._destroying$.complete();
	}
}
